export type CountryCode = 'ES' | 'US' | 'MX' | 'CO' | 'CL' | 'PE'

export type CountryConfig = {
  code: CountryCode
  name: string
  currency: string
  symbol: string
  locale: string
  decimals: 0 | 2
  /** Shopify rounds converted prices up to a clean amount. */
  roundingStep: number
  symbolAfter?: boolean
}

export const COUNTRIES: CountryConfig[] = [
  {
    code: 'ES',
    name: 'España',
    currency: 'EUR',
    symbol: '€',
    locale: 'es-ES',
    decimals: 2,
    roundingStep: 0.01,
    symbolAfter: true,
  },
  {
    code: 'US',
    name: 'Estados Unidos',
    currency: 'USD',
    symbol: '$',
    locale: 'en-US',
    decimals: 0,
    roundingStep: 1,
  },
  {
    code: 'MX',
    name: 'México',
    currency: 'MXN',
    symbol: '$',
    locale: 'es-MX',
    decimals: 0,
    roundingStep: 1,
  },
  {
    code: 'CO',
    name: 'Colombia',
    currency: 'COP',
    symbol: '$',
    locale: 'es-CO',
    decimals: 0,
    roundingStep: 100,
  },
  {
    code: 'CL',
    name: 'Chile',
    currency: 'CLP',
    symbol: '$',
    locale: 'es-CL',
    decimals: 0,
    roundingStep: 1000,
  },
  {
    code: 'PE',
    name: 'Perú',
    currency: 'PEN',
    symbol: 'S/',
    locale: 'es-PE',
    decimals: 0,
    roundingStep: 1,
  },
]

export const DEFAULT_COUNTRY: CountryCode = 'ES'

/**
 * Conversion rates per 1 EUR aligned with the prices Shopify shows at
 * checkout (market rate plus Shopify's conversion fee and rounding rule),
 * so the landing page never contradicts the cart.
 */
export const SHOPIFY_RATES: Record<string, number> = {
  EUR: 1,
  USD: 1.232,
  MXN: 20.5,
  COP: 3772,
  CLP: 1093,
  PEN: 4,
}

export function getCountryConfig(code: CountryCode): CountryConfig {
  return COUNTRIES.find((country) => country.code === code) ?? COUNTRIES[0]
}

export function isSupportedCountry(value: string): value is CountryCode {
  return COUNTRIES.some((country) => country.code === value)
}
